import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/icons/check_mark.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-53e757b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "no-payments-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "check-mark"
}, null, -1))
const _hoisted_3 = { class: "message" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("h3", null, _toDisplayString(_ctx.$t("Payment-completed")), 1),
    _createElementVNode("div", null, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t("Thank-you-message")), 1)
    ])
  ]))
}